module.exports = __webpack_public_path__ + "static/media/ortho-image1.b42f4060.png";